const PERSON_STATUS = {
  created: 'created',
  pending: 'pending',
  validated_by_user: 'validated_by_user',
  validated_by_advisor: 'validated_by_advisor',
  abandoned: 'abandoned',
  completed: 'completed',
  closed: 'closed',
}

const AUTHORIZATIONS = {
  readWrite: 'readWrite',
  advisorWrite: 'advisorWrite',
  readOnly: 'readOnly',
  noAccess: 'noAccess',
}

const PERSON_STATUS_AUTHORIZATION = {
  [PERSON_STATUS.created]: AUTHORIZATIONS.readWrite,
  [PERSON_STATUS.pending]: AUTHORIZATIONS.readWrite,
  [PERSON_STATUS.validated_by_user]: AUTHORIZATIONS.advisorWrite,
  [PERSON_STATUS.validated_by_advisor]: AUTHORIZATIONS.advisorWrite,
  [PERSON_STATUS.abandoned]: AUTHORIZATIONS.readOnly,
  [PERSON_STATUS.completed]: AUTHORIZATIONS.readOnly,
  [PERSON_STATUS.closed]: AUTHORIZATIONS.readOnly,
}

export {
  PERSON_STATUS, AUTHORIZATIONS, PERSON_STATUS_AUTHORIZATION 
}
